export enum ARMRoleName {
  'Visitor' = 'visitor',
  'GarageUser' = 'garageUser',
}
